const getPrivacyLink = (): string => {
  return '/privacy'
}

export { getPrivacyLink }
